export type ApiConfig = {
  /** API Gateway / backend base URL (no trailing slash). */
  baseUrl: string;
  /** When true, use in-memory mock adapter (default if baseUrl is empty). */
  useMock: boolean;
  /**
   * SAML login start URL. Defaults to `{baseUrl}/api/auth/saml/login`
   * when unset and baseUrl is present.
   */
  authLoginUrl: string;
};

export function getApiConfig(): ApiConfig {
  const baseUrl =
    process.env.NEXT_PUBLIC_API_BASE_URL?.replace(/\/$/, "") ?? "";
  const useMockExplicit = process.env.NEXT_PUBLIC_USE_MOCK_API;

  const useMock =
    useMockExplicit === "true" ||
    (useMockExplicit !== "false" && !baseUrl);

  const explicitLoginUrl = process.env.NEXT_PUBLIC_AUTH_LOGIN_URL?.trim() ?? "";
  const authLoginUrl =
    explicitLoginUrl ||
    (baseUrl ? `${baseUrl}/api/auth/saml/login` : "");

  return {
    baseUrl,
    useMock,
    authLoginUrl,
  };
}
